if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-heading-section.production.js');
} else {
  module.exports = require('./react-heading-section.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@team-griffin/react-heading-section/dist/es/react-heading-section.js
// module id = 501
// module chunks = 0